import { LayoutDashboard, Users, Activity, Wallet, LogOut } from 'lucide-react';

export default function AdminLayout({ children, user, onLogout, currentPage }) {
  const navItems = [
    { name: 'Dashboard', icon: LayoutDashboard, path: '/admin', key: 'dashboard' },
    { name: 'Investors', icon: Users, path: '/admin/investors', key: 'investors' },
    { name: 'Investments', icon: Activity, path: '/admin/investments', key: 'investments' },
    { name: 'Payouts', icon: Wallet, path: '/admin/payouts', key: 'payouts' },
  ];

  return (
    <div className="flex min-h-screen bg-background">
      {/* Sidebar */}
      <div className="w-64 bg-card border-r flex flex-col" data-testid="admin-sidebar">
        <div className="p-6 border-b">
          <h2 className="text-xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Factskoot
          </h2>
          <p className="text-sm text-muted-foreground">Admin Portal</p>
        </div>
        
        <nav className="flex-1 p-4 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.key;
            return (
              <a
                key={item.key}
                href={item.path}
                data-testid={`nav-${item.key}`}
                className={`flex items-center space-x-3 px-4 py-3 rounded-md transition-all ${
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-foreground hover:bg-secondary'
                }`}
              >
                <Icon className="w-5 h-5" strokeWidth={1.5} />
                <span className="font-medium">{item.name}</span>
              </a>
            );
          })}
        </nav>
        
        <div className="p-4 border-t">
          <div className="flex items-center space-x-3 px-4 py-3 mb-2">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
              <span className="text-sm font-semibold">{user?.full_name?.charAt(0) || 'A'}</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{user?.full_name}</p>
              <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
            </div>
          </div>
          <button
            data-testid="logout-button"
            onClick={onLogout}
            className="w-full flex items-center space-x-3 px-4 py-3 rounded-md text-destructive hover:bg-destructive/10 transition-all"
          >
            <LogOut className="w-5 h-5" strokeWidth={1.5} />
            <span className="font-medium">Logout</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <div className="p-6 md:p-8 lg:p-12">
          {children}
        </div>
      </div>
    </div>
  );
}